export enum UserRoles {
  USER = 'USER',
  MODERATOR = 'MODERATOR',
  VALIDATOR = 'VALIDATOR',
  NEWSMAKER = 'NEWSMAKER',
  CUP_ORGANIZER = 'CUP_ORGANIZER',
  ADMIN = 'ADMIN',
  SUPERADMIN = 'SUPERADMIN',
  STREAMER = 'STREAMER',
  WARCUP_ADMIN = 'WARCUP_ADMIN',
}
